import type { HeroConfig } from '@src/components/sco/LayoutBlocks/Hero/types'

export const investorMatchingLandingHeroConfig: HeroConfig = {
  title: 'Raise Capital 10x Faster',
  description: 'Automate your fundraise with investor matching and outreach',
  backgroundColor: 'colorPalette.bg',
  backgroundGradient: 'linear(to-t, blackAlpha.500 25%, transparent 75%)',
  howItWorksCards: [
    {
      title: 'Match with Ideal Investors',
      description:
        "Upload your pitch deck and we'll curate a targeted list of the most relevant investors for your deal.",
      image: require('@public/assets/graphics/explainer/your-request.png'),
    },
    {
      title: 'Prepare Your Ideal Pitch',
      description: 'Our Pitch Builder generates individualized emails to send to your matched investors.',
      image: require('@public/assets/graphics/explainer/get-matched.png'),
    },
    {
      title: 'Automated Investor Outreach',
      description: 'Connect your email account and fast-track sending investor pitches with full tracking.',
      image: require('@public/assets/graphics/explainer/focus-on-tasks.png'),
    },
  ],
}
